import React ,{Component} from 'react';
import classes from './project.module.css';
import Data from '../data/data.js';
import Project from './Projectcard.js';
import { motion } from "framer-motion";


  class project extends Component {
      state = {
          Data:Data
      }
   
      default = ()=>{
          
          this.setState({Data:Data})
      }
      handelproject = (name)=>{
         // console.log(this.state.Data);
          const D  = Data;
        const data =   D.filter(project=>project.type.includes(name));
        this.setState({Data:data});
      }

    render(){
        const ani1 = {
            hidden:{
                y:'20vh',
                
                opacity:0
            },
            visible:{
                y:0,
                
                opacity:1,
                transition:{
                    delay:0.2,duration:0.8,type:'spring'
                },
                exit:{
                    x: -300, opacity: 0 ,
                    transition:{
                        delay:3,duration:0.6,type:'spring'
                    }
                }
                
          
            }
          }
        const c1 = [classes.project];
        return(

            <div>
           
            <div className={c1.join(' ')}>
            <div className={classes.projectnav}>
        <div className={classes.projectnav1} onClick={()=>this.default()} >All</div>
        <div className={classes.projectnav1} onClick={()=>this.handelproject('react.js')}>React.js</div>
        <div className={classes.projectnav1} onClick={()=>this.handelproject('node.js')}>Node.js</div>
        <div className={classes.projectnav1} onClick={()=>this.handelproject('vanillajs')}>VanillaJs</div>
        <div className={classes.projectnav1} onClick={()=>this.handelproject('Jquery')}>Jquery</div>
        <div className={classes.projectnav1} onClick={()=>this.handelproject('C++')}>C++</div>
    </div>
                <motion.div className="row container"
                 variants={ani1}
                 initial='hidden'
                 animate='visible'
                 exit='exit'
                >
                    {
                       this.state.Data.map(data=><Project info={data} key={data.name} />)
                    }
    
                </motion.div>
            </div>
            </div>
        )
    }
    

    //console.log(Data);
    
    
    
}
export default project;